import jsPDF from 'jspdf';
import moment from 'moment';
const qr = require('qrcode');

import imageUrl from '../../../assets/formato.png'; // Esto hace que Webpack gestione la imagen correctamente

async function generarCodigoQR(_idVisita) {
    const cadenaQR = _idVisita
    try {
        let base64QR = "";
        await qr.toDataURL(cadenaQR, (err, url) => {
            if (err) {
                throw err;
            }
            base64QR = url.split(',')[1];
        });
        return base64QR;
    } catch (error) {
        throw error;
    }
}

// Función para convertir una imagen a base64
const getImageBase64FromURL = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

const FormatoNotificacionVariablesPDF = async (fecha_pago, items) => {
    return new Promise(async (resolve, reject) => {
        try {
            const doc = new jsPDF({
                format: 'letter' // Tamaño de la página es 8.5 x 11 pulgadas
            });

            // Convertir la imagen a base64
            // const imageBase64 = await getImageBase64FromURL(imageUrl);

            // Obtener el tamaño de la página en puntos
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            for (const item of items) {
                if (items.indexOf(item) > 0) {
                    doc.addPage(); // Añadir una nueva página para cada item (excepto el primero)
                }

                const codigoQR = await generarCodigoQR(item._id);
                doc.addImage(codigoQR, 'PNG', 30, 215, 30, 30);

                doc.setTextColor("#4B5265");

                doc.setFontSize(9);
                doc.setFont('helvetica', 'bold');

                doc.text(item.deudor.marca, 26, 136.5, { align: 'left' });
                doc.text(item.deudor.modelo, 117, 136.5, { align: 'left' });
                doc.text(item.deudor.placa, 49, 145.3, { align: 'left' });
                doc.text(item.deudor.ultimo_ejercicio_pagado + ' - 2024', 65, 154, { align: 'left' });
                doc.setFontSize(10);
                doc.setFont('helvetica', 'bold');
                doc.text(item.deudor.nombre, 131, 50.5, { align: 'left' });

                doc.setFontSize(12);
                doc.text(item.deudor.total_pagar_descuentos, 135, 33, { align: 'center' });
                doc.setFontSize(10);

                doc.text(fecha_pago, 183, 33, { align: 'center' });

                doc.setFontSize(8);
                doc.text(item.deudor.municipio_deudor, 113.5, 77.5, { align: 'left' });
                const texto = item.deudor.localidad + ', ' + item.deudor.fraccionamiento_colonia + ', ' + item.deudor.calle + ', CP ' + item.deudor.codigo_postal;
                const maxLineWidth = 90;
                const textoDividido = doc.splitTextToSize(texto, maxLineWidth);
                const x = 113.5;
                const y = 60;
                doc.text(textoDividido, x, y);

                const valorDecimal = parseFloat(item.deudor.total_pagar_descuentos.replace(/[$,]/g, ''));

                doc.setFontSize(9);
                const func = require('./numeroALetras.js')
                let a = func.numeroALetras(valorDecimal, 'MXN')
                //  doc.text(a, 65, 154, { align: 'left' });

                const maxWidth = 160;  // Máxima posición en la primera línea
                const lineHeight = 10;
                const textWidth = doc.getTextWidth(a);

                // Si el texto excede el maxWidth, divídelo
                if (textWidth > maxWidth - 160) {
                    // Divide el texto en la primera parte que cabe hasta 150 y el resto
                    const splitText = doc.splitTextToSize(a, maxWidth - 100);

                    // Dibuja la primera parte del texto en la posición inicial
                    doc.text(splitText[0], 142, 153.7, { align: 'left' });

                    // Dibuja el resto en la siguiente línea, comenzando en la posición 25
                    for (let i = 1; i < splitText.length; i++) {
                        doc.text(splitText[i], 13, 153.5 + lineHeight * i, { align: 'left' });
                    }
                } else {
                    // Si no es necesario dividir el texto, solo colócalo en la posición original
                    doc.text(a, 100, 153.6, { align: 'left' });
                }
            }
            const base64 = doc.output('datauristring');
            let nombreDoc = 'nombreArchivo';
            resolve(base64);

        } catch (error) {
            console.log(error);
            reject(error);
        }
    });
};
export { FormatoNotificacionVariablesPDF };
